export default __webpack_public_path__ + "static/illustration-invention-funnel-a0da35d00ecaa73110ea265701c4ec01.svg";